// extracted by mini-css-extract-plugin
module.exports = {"container":"TableEmptyState_container__es5OQ","icon":"TableEmptyState_icon__oZ_Y_","description":"TableEmptyState_description__P4Dnl"};